import { render, staticRenderFns } from "./MoreRestaurantsTakenChart.vue?vue&type=template&id=63df1366"
import script from "./MoreRestaurantsTakenChart.vue?vue&type=script&lang=js"
export * from "./MoreRestaurantsTakenChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports